import React, { useState, useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import jwt_decode from "jwt-decode";
import AuthLayout from "../layouts/AuthLayout";
import ResetPasswordForm from "../components/ResetPasswordForm";

function ResetPassword() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [resetData, setResetData] = useState();

  const _checkValidToken = () => {
    try {
      const data = jwt_decode(searchParams.get("reset_code"));
      const expiredTime = data.expire_on * 1000 - new Date().getTime();
      navigate(window.location.pathname, { replace: true });
      if (expiredTime > 0) {
        setResetData(data);
        return expiredTime;
      }
      throw new Error("token expired");
    } catch (err) {
      console.log(err);
      navigate("/login");
    }
  };

  useEffect(() => {
    let expiredTimeout;
    const expiredTime = _checkValidToken();
    if (expiredTime) {
      expiredTimeout = setTimeout(() => {
        navigate("/login");
      }, expiredTime);
    }
    return () => {
      clearTimeout(expiredTimeout);
    };
  }, []); // eslint-disable-line

  if (!resetData) {
    return null;
  }

  return (
    <AuthLayout>
      <ResetPasswordForm data={resetData} />
    </AuthLayout>
  );
}

export default ResetPassword;
